import $ from 'jquery';
export const mediaQuerySp = window.matchMedia('(max-width: 640px)');

export const countUpAction = (obj, fixCount) => {
    $(obj).attr('data-count', fixCount);
    $(obj).animate(
        {
            Counter: fixCount,
        },
        {
            duration: 300,
            easing: "swing",
            step: (now, e) => {
                $(e.elem).text(Math.ceil(now));
            },
        }
    );
};

const main = () => {
    // pg-footer-searchが読み込まれたらクリックイベントをセット
    if (!document.querySelector('.pg-footer-search')) return;
    document.querySelector('.pg-footer-search').addEventListener('onLoadContents', () => {
        document.querySelectorAll('.pg-footer-search__item').forEach(item => {
            item.addEventListener('click', () => {
                if (item.hasAttribute('data-is-open')) {
                    delete item.dataset.isOpen;
                } else {
                    item.dataset.isOpen = '';
                }
            });
        });
    });
}
export default main;
